import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import {
  getOnboardingConfiguration,
  setUserOnbordingStatus,
} from 'modules/Onboarding/api/onboardingService'
import { OnboardingState, ApiConfigurationResponse, ApiSetOnbordingStatusResponse } from './types'

const initialState: OnboardingState = {
  configuration: {},
  setOnbordingStatusRequest: {},
  viewed: false,
}

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    configurationLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiConfigurationResponse>>
    ) {
      state.configuration = action.payload
    },
    setUserOnbordingStatusRequested(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSetOnbordingStatusResponse>>
    ) {
      state.setOnbordingStatusRequest = action.payload
    },
    visibilityChanged(state, action: PayloadAction<boolean>) {
      state.viewed = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { configurationLoaded, visibilityChanged, setUserOnbordingStatusRequested } =
  onboardingSlice.actions

export default onboardingSlice.reducer

export const loadOnboardingConfiguration = () => {
  return createApiAction({
    apiCalls: {
      configuration: getOnboardingConfiguration,
    },
    payloadAction: configurationLoaded,
    enableErrorNotification: true,
  })
}

export const setBackendOnbordingStatus = (viewed: boolean) => {
  return createApiAction({
    apiCalls: {
      setOnbordingStatus: () => setUserOnbordingStatus(viewed),
    },
    payloadAction: setUserOnbordingStatusRequested,
  })
}

export const setOnboardingViewedState = visibilityChanged
